import * as React from 'react'
import { Flex } from 'grid-styled'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { Helmet } from 'react-helmet'
import Hero from '../../components/Hero'
import Button from '../../components/Button'
import BackgroundSection from '../../components/BackgroundSection'
import MainLayout from '../../components/Layout'
import { AboutContact } from '..'
import {
  BeforeAfter,
  StyledTabs,
  StyledTabList,
  StyledTab,
  Content,
  Video,
} from '../../components/procedures'
import { TabPanel } from 'react-tabs'

const content = {
  backgroundTitle: 'Other Non-Surgical Options',
  subtitle: `Trusted, Experienced & Ethical. Boutique plastic surgery on Sydney's North Shore.`,
  title: 'Wrinkle Treatments',
  otherOptions: [
    {
      text: 'Dermal Fillers',
      to: '/non-surgical/dermal-fillers',
    },
    // {
    //   text: 'Cool Sculpting',
    //   to: '/non-surgical/coolsculpting',
    // },
    {
      text: 'Skin Care',
      to: '/non-surgical/skin-treatments',
    },
    {
      text: 'Excess Underarm Sweating',
      to: '/non-surgical/excess-underarm-sweating',
    },
    {
      text: 'Anti-Wrinkle Injections',
      to: '/non-surgical/muscle-relaxants',
    },
    // {
    //   text: 'IPL & Laser Treatments',
    //   to: '/non-surgical/ipl-and-laser-treatments'
    // }
  ],
}

export default ({ data }) => (
  <MainLayout header="light">
    <Helmet>
      <title>Anti Wrinkle Injections - Plastic Surgery Sydney</title>
      <meta
        name="description"
        content="Look and feel younger as Dr. Graham uses anti wrinkle injections to remove those lines around your eyes and mouth."
      />
    </Helmet>

    <Hero bgImage={data.womanWaterfall.childImageSharp} height="600px">
      <h1>{content.title}</h1>
      <p>{content.subtitle}</p>
      <Flex>
        <Button color="#fff" small={true} outline={true}>
          Learn more
        </Button>
      </Flex>
    </Hero>

    <Content>
      <h2>Muscle Relaxants</h2>
      <p>
        Unfortunately as we age lines on the face appear. And living in
        Australia, sun-damage is just a part of life.
      </p>
      <p>
        The cause of wrinkles is varied, however, when you laugh, frown,
        concentrate or squint your facial muscles contract, causing wrinkles to
        form. These wrinkles can leave you looking tired, sad or angry. In
        particular, the frown lines are a concern for most people.
      </p>

      <p>
        Anti-Wrinkle injections (botulinum toxin) can relax these muscles for a
        period of a few months, thus softening or eliminating wrinkles on the
        surface of the skin.
      </p>

      <Link to="/contact/">
        <Button inverted={true}>Contact us today!</Button>
      </Link>
    </Content>

    {/* <Video
      videoId="DrNLSFBEAKo"
      opts={{
        height: '576',
        width: '1024',
        playerVars: {
          color: 'white',
          rel: 0,
        },
      }}
    /> */}

    <BackgroundSection
      image={data.otherBreast.childImageSharp}
      title={content.backgroundTitle}
      height="500px"
      darkness="0.4"
    >
      <p style={{ fontSize: 18, margin: '-1rem 0 2rem' }}>
        Browse Dr. Graham Sellars' full range of surgical and non-surgical
        procedures.
      </p>
      {content.otherOptions.map(({ to, text }) => (
        <Flex mr={2} mb={3} style={{ float: 'left' }}>
          <Link to={to}>
            <Button small={true} color="#fff" outline={true}>
              {text}
            </Button>
          </Link>
        </Flex>
      ))}
    </BackgroundSection>

    <StyledTabs style={{ marginTop: 50 }}>
      <h2>Information about {content.title}</h2>
      <StyledTabList>
        <StyledTab>History</StyledTab>
        <StyledTab>How it works</StyledTab>
        <StyledTab>The procedure</StyledTab>
        <StyledTab>Risks</StyledTab>
      </StyledTabList>

      <TabPanel>
        <p>
          The initial use of Anti-Wrinkle injections (botulinum toxin) were for
          uncontrolled muscle spasms, or contractures. Initially it was used in
          cases of Blepharospasm (spasm of the eyelid) and facial spasms. It was
          also used for Cerebral Palsy where there was spasm of certain muscles,
          and deformed hand and foot function. By injecting into the muscles
          that had spasm, they were able to relax and return to normal function.
        </p>

        <p>
          Through the use of this product in areas of the face, it was noted
          that not only did it control spasms of the eyelids, but the wrinkles
          around the eyes had disappeared. Thus the use of it as a cosmetic
          treatment for wrinkles soon developed.
        </p>
      </TabPanel>
      <TabPanel>
        <p>
          Anti-Wrinkle injections are a protein extracted from the naturally
          occurring bacterium, Clostridium botulinum. The protein works by
          blocking the nerve impulses to the injected muscles. The muscles that
          are specific to causing wrinkles are targeted, allowing these muscles
          to relax. Once the muscles are relaxed, the overlying wrinkles soften
          or disappear.
        </p>
      </TabPanel>
      <TabPanel>
        <p>
          The patient is assessed by Dr. Sellars or his nurse injector, and may
          be photographed.
        </p>

        <p>
          A dose will be decided upon, and this will be injected directly into
          the area involved. (Each client is individual and will have an
          individual requirement). Following this, the relaxation of the
          targeted muscles will take place between 3 to 10 days after the
          injection.
        </p>

        <p>The effects of muscle relaxation will last between 3-6 months.</p>
      </TabPanel>
      <TabPanel>
        <p>
          You may occasionally develop a small bruise, redness or slight
          tenderness at the injection site. Some patients report a headache for
          a day or two after treatment. A transient eyelid droop may develop but
          this is a rare event. There are some extremely rare complications
          reported, and these can be discussed at consultation.
        </p>

        <p>
          Please note that Anti-Wrinkle injections cannot be given to pregnant
          or breast-feeding clients.
        </p>
      </TabPanel>
    </StyledTabs>

    <BeforeAfter>
      <h2>Before &amp; After</h2>
      <div>
        {data.allFile.edges.map(
          (image) =>
            image.node.childImageSharp && (
              <Img resolutions={image.node.childImageSharp.resolutions} />
            )
        )}
      </div>
      <Flex justifyContent="center">
        <Link to="/gallery">
          <Button inverted={true}>See the full gallery</Button>
        </Link>
      </Flex>
    </BeforeAfter>

    <AboutContact data={data} />
  </MainLayout>
)
export const query = graphql`
  query AntiWrinkleQuery {
    allFile(filter: { relativeDirectory: { eq: "muscle-relaxants" } }) {
      edges {
        node {
          childImageSharp {
            resolutions(width: 500, toFormat: JPG) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
    womanWaterfall: file(relativePath: { eq: "wrinkle-treatment.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 3000, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    otherBreast: file(relativePath: { eq: "non-surgical-woman.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    asaps: file(relativePath: { eq: "ASAPS.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    asps: file(relativePath: { eq: "ASPS.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    drSellars: file(relativePath: { eq: "dr-graham-sellars.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    fracs: file(relativePath: { eq: "FRACS.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
